import { ReactComponent as IconClose } from "@/assets/svgs/icon-close.svg";
import { assetUrl } from '@/utils/asset-url';
import iconSearch from "@/assets/svgs/icon-search.svg";
import { ReactComponent as Paticipant } from "@/assets/svgs/participant.svg";
import Button from "@/components/Button/index";
import CardConfigure from '@/componentsDS/Modal/CardConfigure';
import Modal from '@/componentsDS/Modal/Modal';
import rem from "@/utils/rem";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { feature, features } from '@/utils/feature-verifier';
import Search from '@/componentsDS/Search/index';

function Header(title) {
	return (
		<CardConfigure.Header>
			<CardConfigure.Header.Title>
				<div className="card-configure__header__left">
					<div className="card-configure__title">
						<div className="card-configure__title__left">
							<div className={'card-configure__icon'}>
								<Paticipant />
							</div>
						</div>
						<div className="card-configure__title__right">
							<div className="card-configure__title__right__top">
								{title}
							</div>
						</div>
					</div>
				</div>
			</CardConfigure.Header.Title>
		</CardConfigure.Header>
	);
}

export default function ChangeReceipientModal({
	selected,
	showConfirm,
	isVisible,
	close,
	data,
}) {
	const { t } = useTranslation();
	const [isConfirmVisible, setShowConfirm] = useState(showConfirm);
	const [tempSelected, setTempSelected] = useState(null);
	const [searchReceipientText, setSearchReceipientText] = useState("");

	const handleReceipientSearchInput = (event) => {
		setSearchReceipientText(event.target.value);
	};


	useEffect(() => {
		setTempSelected(selected);
		setShowConfirm(showConfirm);
	}, [selected, showConfirm]);

	const title = selected ? t("changeRecipient") : t("addRecipient");

	if (isConfirmVisible) {
		return (
			<Modal visible={isVisible} variant="medium" close={close}>
				<CardConfigure >
					{Header(title)}
					<CardConfigure.Body>
						<CardConfigure.Body.Col>
							<div className="eclip-create__confirmation">
								Are you sure want to change the recipient ?
								Changing the recipient will also remove the
								added Data Elements as well ? Kindly confirm.
							</div>
						</CardConfigure.Body.Col>
					</CardConfigure.Body>
					<CardConfigure.Footer>
						<CardConfigure.Footer.Right>
							<Button
								ghost
								text="Cancel"
								submit={() => {
									close();
								}}
							/>
							<span className="btn-spacing"></span>

							<Button
								text="Next"
								submit={() => {
									setShowConfirm(false);
								}}
							/>
						</CardConfigure.Footer.Right>
					</CardConfigure.Footer>
				</CardConfigure>
			</Modal>
		);
	}

	return (
		<Modal visible={isVisible} variant="medium" close={close}>
			<CardConfigure>
				{Header(title)}
				<CardConfigure.Body>
					<CardConfigure.Body.Col>
						<div className="eclip-create__upload__form">
							<div className="eclip-receipient__input">
								<Search
									value={searchReceipientText}
									placeholder='Search'
									onChange={handleReceipientSearchInput}
									onCancel={() => setSearchReceipientText('')}
								/>
							</div>
							<ul className="eclip-receipient__list">
								{data
									?.filter(
										(item) =>
											item?.name?.trim().length === 0 ||
											item?.name
												?.toLowerCase()
												.includes(
													searchReceipientText.toLowerCase()
												)
									)
									.map((item, index) => (
										<li
											key={index}
											className={`eclip-receipient__list-item ${
												tempSelected?.id === item?.id
													? "selected"
													: ""
											}`}
											onClick={() => {
												if (tempSelected?.id === item?.id) {
													return setTempSelected(null);
												}

												setTempSelected(item);
											}}
										>
											<div
												className="eclip-receipient__icon"
												style={{
													backgroundImage: `url(${item?.iconUrl})`,
												}}
											></div>
											<div className="eclip-receipient__name">
												{item?.name}
											</div>
										</li>
									))}
							</ul>
						</div>
					</CardConfigure.Body.Col>
				</CardConfigure.Body>
				<CardConfigure.Footer>
					<CardConfigure.Footer.Right>
						<Button
							ghost
							text="Cancel"
							submit={() => {
								close();
							}}
						/>
						<span className="btn-spacing"></span>

						<Button
							text="Confirm"
							disabled={tempSelected === null}
							submit={() => {
								close(tempSelected);
							}}
						/>
					</CardConfigure.Footer.Right>
				</CardConfigure.Footer>
			</CardConfigure>
		</Modal>
	);
}
